import { createContext } from 'react'
import { noop } from 'utils'

export const ImageLibraryModalContext = createContext({
  afterConfirmRef: noop,
  type: undefined,
})
